import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlipHorizontalCircle32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconFlipHorizontalCircle32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M7.97 19.602a8.8 8.8 0 0 0 16.059 0h2.576c-1.5 4.418-5.68 7.6-10.606 7.6l-.576-.016c-4.673-.236-8.59-3.339-10.03-7.584zm21.232-4.787a1.2 1.2 0 0 1 0 2.4H2.8a1.2 1.2 0 0 1 0-2.4zm-12.626-10c4.674.237 8.59 3.34 10.03 7.586H24.03a8.8 8.8 0 0 0-8.03-5.2 8.8 8.8 0 0 0-8.029 5.2H5.393c1.5-4.419 5.68-7.6 10.607-7.6z"
            />
        </svg>
    );
}
export default memo(IconFlipHorizontalCircle32);
